import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const fieldsByParameter = {
  orderId: ['OrderId', 'orderId', 'order_id', 'id', 'Id', 'ID', 'ref'],
  requisiteId: ['requisiteId', 'RequisiteId', 'id', 'Id', 'ID', 'ref'],
  deviceId: ['deviceId', 'DeviceId', 'id', 'Id', 'ID', 'ref'],
  gatewayId: ['gatewayId', 'GatewayId', 'id', 'Id', 'ID', 'ref'],
  traderId: ['traderId', 'TraderId', 'TRADER_ID', 'id', 'Id', 'ID', 'ref'],
  priceId: ['priceId', 'PriceId', 'id', 'Id', 'ID', 'ref'],
  messageId: ['messageId', 'MessageId', 'id', 'Id', 'ID', 'ref'],
  transactionId: ['transactionId', 'TransactionId', 'id', 'Id', 'ID', 'ref'],
  bankId: ['bankId', 'BankId', 'id', 'Id', 'ID', 'ref'],
  currencyId: ['currencyId', 'CurrencyId', 'id', 'Id', 'ID', 'ref']
};

const getRecordId = (record, parameterName) => {
  if (!record) return null;

  const fields = fieldsByParameter[parameterName] || ['id', 'Id', 'ID', 'ref'];
  const sources = [record.data, record].filter(Boolean);

  for (const source of sources) {
    for (const field of fields) {
      const value = source[field];
      if (value !== undefined && value !== null && value !== '') {
        return String(value);
      }
    }
  }

  return null;
};

const useUrlDetails = (records, parameterName) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedRecord, setSelectedRecordState] = useState(null);
  const requestedId = searchParams.get(parameterName);

  useEffect(() => {
    if (!requestedId) {
      setSelectedRecordState(null);
      return;
    }

    const matchingRecord = records.find(
      (record) => getRecordId(record, parameterName) === requestedId
    );

    setSelectedRecordState(matchingRecord || null);
  }, [parameterName, records, requestedId]);

  const setSelectedRecord = useCallback((record) => {
    const recordId = getRecordId(record, parameterName);

    setSearchParams((previousParams) => {
      const nextParams = new URLSearchParams(previousParams);

      if (record && recordId) {
        nextParams.set(parameterName, recordId);
      } else {
        nextParams.delete(parameterName);
      }

      return nextParams;
    });

    setSelectedRecordState(record || null);
  }, [parameterName, setSearchParams]);

  return [selectedRecord, setSelectedRecord];
};

export default useUrlDetails;
